"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sponsorships = void 0;
const AxiosHttpRequest_1 = require("./core/AxiosHttpRequest");
const AccountsService_1 = require("./services/AccountsService");
const ActionsService_1 = require("./services/ActionsService");
const AdvertisersService_1 = require("./services/AdvertisersService");
const AgenciesService_1 = require("./services/AgenciesService");
const AttributionService_1 = require("./services/AttributionService");
const AuditLogService_1 = require("./services/AuditLogService");
const AuthService_1 = require("./services/AuthService");
const BulkActionsService_1 = require("./services/BulkActionsService");
const CampaignsService_1 = require("./services/CampaignsService");
const CampaignsExperimentsService_1 = require("./services/CampaignsExperimentsService");
const ConfigService_1 = require("./services/ConfigService");
const CreatorsService_1 = require("./services/CreatorsService");
const DataMigrationService_1 = require("./services/DataMigrationService");
const DeliverablesService_1 = require("./services/DeliverablesService");
const DeliverableTrackingService_1 = require("./services/DeliverableTrackingService");
const DeploymentsService_1 = require("./services/DeploymentsService");
const DeploymentsAdvertiserEventsService_1 = require("./services/DeploymentsAdvertiserEventsService");
const DeploymentsDeliverablesService_1 = require("./services/DeploymentsDeliverablesService");
const DeploymentsEligibilityService_1 = require("./services/DeploymentsEligibilityService");
const DeploymentsFraudService_1 = require("./services/DeploymentsFraudService");
const DeploymentsPersonalisedOutreachService_1 = require("./services/DeploymentsPersonalisedOutreachService");
const EmailsService_1 = require("./services/EmailsService");
const ExperimentsService_1 = require("./services/ExperimentsService");
const ExternalEventsService_1 = require("./services/ExternalEventsService");
const FileProcessService_1 = require("./services/FileProcessService");
const GroupsService_1 = require("./services/GroupsService");
const GroupsEligibilityService_1 = require("./services/GroupsEligibilityService");
const HealthService_1 = require("./services/HealthService");
const HellofreshService_1 = require("./services/HellofreshService");
const I18NService_1 = require("./services/I18NService");
const InternalService_1 = require("./services/InternalService");
const InternalImportService_1 = require("./services/InternalImportService");
const InternalOutreachService_1 = require("./services/InternalOutreachService");
const ManagersService_1 = require("./services/ManagersService");
const ManualFlowService_1 = require("./services/ManualFlowService");
const NoteCommentsService_1 = require("./services/NoteCommentsService");
const NotesService_1 = require("./services/NotesService");
const OutreachService_1 = require("./services/OutreachService");
const OutreachInfoService_1 = require("./services/OutreachInfoService");
const PersonalisedOutreachService_1 = require("./services/PersonalisedOutreachService");
const PromoCodeListsService_1 = require("./services/PromoCodeListsService");
const PromoCodesService_1 = require("./services/PromoCodesService");
const ReportingReportsService_1 = require("./services/ReportingReportsService");
const SearchService_1 = require("./services/SearchService");
const SendGridService_1 = require("./services/SendGridService");
const SponsorshipsService_1 = require("./services/SponsorshipsService");
const StatsService_1 = require("./services/StatsService");
const SupportTicketsService_1 = require("./services/SupportTicketsService");
const TikTokAdvertiserService_1 = require("./services/TikTokAdvertiserService");
const TimelineService_1 = require("./services/TimelineService");
const TypesService_1 = require("./services/TypesService");
const WorkflowAutomationService_1 = require("./services/WorkflowAutomationService");
class Sponsorships {
    constructor(config, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.accounts = new AccountsService_1.AccountsService(this.request);
        this.actions = new ActionsService_1.ActionsService(this.request);
        this.advertisers = new AdvertisersService_1.AdvertisersService(this.request);
        this.agencies = new AgenciesService_1.AgenciesService(this.request);
        this.attribution = new AttributionService_1.AttributionService(this.request);
        this.auditLog = new AuditLogService_1.AuditLogService(this.request);
        this.auth = new AuthService_1.AuthService(this.request);
        this.bulkActions = new BulkActionsService_1.BulkActionsService(this.request);
        this.campaigns = new CampaignsService_1.CampaignsService(this.request);
        this.campaignsExperiments = new CampaignsExperimentsService_1.CampaignsExperimentsService(this.request);
        this.config = new ConfigService_1.ConfigService(this.request);
        this.creators = new CreatorsService_1.CreatorsService(this.request);
        this.dataMigration = new DataMigrationService_1.DataMigrationService(this.request);
        this.deliverables = new DeliverablesService_1.DeliverablesService(this.request);
        this.deliverableTracking = new DeliverableTrackingService_1.DeliverableTrackingService(this.request);
        this.deployments = new DeploymentsService_1.DeploymentsService(this.request);
        this.deploymentsAdvertiserEvents = new DeploymentsAdvertiserEventsService_1.DeploymentsAdvertiserEventsService(this.request);
        this.deploymentsDeliverables = new DeploymentsDeliverablesService_1.DeploymentsDeliverablesService(this.request);
        this.deploymentsEligibility = new DeploymentsEligibilityService_1.DeploymentsEligibilityService(this.request);
        this.deploymentsFraud = new DeploymentsFraudService_1.DeploymentsFraudService(this.request);
        this.deploymentsPersonalisedOutreach = new DeploymentsPersonalisedOutreachService_1.DeploymentsPersonalisedOutreachService(this.request);
        this.emails = new EmailsService_1.EmailsService(this.request);
        this.experiments = new ExperimentsService_1.ExperimentsService(this.request);
        this.externalEvents = new ExternalEventsService_1.ExternalEventsService(this.request);
        this.fileProcess = new FileProcessService_1.FileProcessService(this.request);
        this.groups = new GroupsService_1.GroupsService(this.request);
        this.groupsEligibility = new GroupsEligibilityService_1.GroupsEligibilityService(this.request);
        this.health = new HealthService_1.HealthService(this.request);
        this.hellofresh = new HellofreshService_1.HellofreshService(this.request);
        this.i18N = new I18NService_1.I18NService(this.request);
        this.internal = new InternalService_1.InternalService(this.request);
        this.internalImport = new InternalImportService_1.InternalImportService(this.request);
        this.internalOutreach = new InternalOutreachService_1.InternalOutreachService(this.request);
        this.managers = new ManagersService_1.ManagersService(this.request);
        this.manualFlow = new ManualFlowService_1.ManualFlowService(this.request);
        this.noteComments = new NoteCommentsService_1.NoteCommentsService(this.request);
        this.notes = new NotesService_1.NotesService(this.request);
        this.outreach = new OutreachService_1.OutreachService(this.request);
        this.outreachInfo = new OutreachInfoService_1.OutreachInfoService(this.request);
        this.personalisedOutreach = new PersonalisedOutreachService_1.PersonalisedOutreachService(this.request);
        this.promoCodeLists = new PromoCodeListsService_1.PromoCodeListsService(this.request);
        this.promoCodes = new PromoCodesService_1.PromoCodesService(this.request);
        this.reportingReports = new ReportingReportsService_1.ReportingReportsService(this.request);
        this.search = new SearchService_1.SearchService(this.request);
        this.sendGrid = new SendGridService_1.SendGridService(this.request);
        this.sponsorships = new SponsorshipsService_1.SponsorshipsService(this.request);
        this.stats = new StatsService_1.StatsService(this.request);
        this.supportTickets = new SupportTicketsService_1.SupportTicketsService(this.request);
        this.tikTokAdvertiser = new TikTokAdvertiserService_1.TikTokAdvertiserService(this.request);
        this.timeline = new TimelineService_1.TimelineService(this.request);
        this.types = new TypesService_1.TypesService(this.request);
        this.workflowAutomation = new WorkflowAutomationService_1.WorkflowAutomationService(this.request);
    }
}
exports.Sponsorships = Sponsorships;
